import { Group, Indicator, Paper, Skeleton, Stack, Text, Tooltip } from "@mantine/core";
import type { ChecklistSummaryStats } from "./hooks/useChecklistSummaryQuery";
import { AlertCircle } from "./icons/AlertCircle";
import { HelpCircle } from "./icons/HelpCircle";

export interface ChecklistSummaryViewProps {
    stats?: ChecklistSummaryStats;
    isLoading: boolean;
}

export function ChecklistSummaryView({ stats, isLoading }: ChecklistSummaryViewProps) {
    return (
        <Paper bg="dark.7" pt="md" radius="md">
            <Stack>
                <Stack px="md" gap="3xs">
                    <Group justify="space-between">
                        <Tooltip label="Percentage shows how often each checklist item was completed" zIndex={1000}>
                            <Group gap="3xs" style={{ cursor: "pointer" }}>
                                <Text fw="bold" size="xs">
                                    Smart Offer Summary
                                </Text>
                                <HelpCircle />
                            </Group>
                        </Tooltip>
                        <Group gap="xxs">
                            <Indicator size={6} processing />
                            <Text size="xxs" c="dark.2">
                                Live
                            </Text>
                        </Group>
                    </Group>
                    <Group>
                        <Skeleton visible={isLoading}>
                            <Text size="xs">{stats?.sessionCount} eligible calls</Text>
                        </Skeleton>
                    </Group>
                </Stack>
                <Stack px="md" pb="md">
                    <Skeleton visible={isLoading} h={isLoading ? "206px" : undefined}>
                        <Stack gap={0}>
                            {stats == null ? (
                                <Text>Oh no! Something went wrong</Text>
                            ) : (
                                stats.checklistSummaryRows.map(({ behavior, percent, isInvalidData, isWarning }) => {
                                    return (
                                        <Group
                                            key={behavior}
                                            justify="space-between"
                                            py="xxs"
                                            px="sm"
                                            c={isWarning ? "warning.0" : undefined}
                                        >
                                            <Text fw={isWarning ? "bold" : undefined} size="xs">
                                                {behavior}
                                            </Text>
                                            {isInvalidData ? (
                                                <Text size="xs">N/A</Text>
                                            ) : (
                                                <Group gap="3xs">
                                                    {isWarning && <AlertCircle />}
                                                    <Text size="xs">{percent}%</Text>
                                                </Group>
                                            )}
                                        </Group>
                                    );
                                })
                            )}
                            <Group
                                justify="space-between"
                                pt="md"
                                styles={{ root: { borderTop: "1px solid var(--mantine-color-dark-5)" } }}
                            >
                                <Text>Offer score</Text>
                                <Text>{stats?.overallAdherencePercentDisplay}</Text>
                            </Group>
                        </Stack>
                    </Skeleton>
                </Stack>
            </Stack>
        </Paper>
    );
}
